import { apiClient as api } from './api';
import { callV3, type ApiResponse } from '../api/envelope';
import type {
  FavoriteDto,
  FavoriteTargetType,
  ToggleFavoriteRequest,
  ToggleFavoriteResponse,
} from '../domain';

const FAVORITES_BASE = '/api/v3/favorites';

/**
 * Path C Favorites API (Slice 4). Polymorphic — favorite an Asset or a
 * Collection. `toggle` is idempotent and returns the new state, a good fit for
 * optimistic UI (see useToggleFavorite).
 */
export const FavoriteService = {
  toggle: (request: ToggleFavoriteRequest) =>
    callV3<ToggleFavoriteResponse>(
      api.post<ApiResponse<ToggleFavoriteResponse>>(`${FAVORITES_BASE}/toggle`, request),
    ),

  list: (targetType?: FavoriteTargetType) =>
    callV3<FavoriteDto[]>(
      api.get<ApiResponse<FavoriteDto[]>>(FAVORITES_BASE, {
        params: targetType ? { targetType } : undefined,
      }),
    ),
};
